export default __webpack_public_path__ + "static/media/LesPetitsCafes60s.73492f7e.mp3";